export default "__VITE_ASSET__BQbOP4PZ__"